import { MAX_WIDTH_SIDE_PEEK, MIN_WIDTH_SIDE_PEEK } from '@/lib/constants';

export const constrainWidth = (width, windowWidth) => {
  if (width < MIN_WIDTH_SIDE_PEEK) {
    return MIN_WIDTH_SIDE_PEEK;
  }
  if (width >= windowWidth * MAX_WIDTH_SIDE_PEEK) {
    return Math.round(windowWidth * MAX_WIDTH_SIDE_PEEK);
  }
  return width;
};

export const layoutWidth = ({ open, width, windowWidth }) => {
  if (!open || !Number.isFinite(width)) {
    return 0;
  }
  return constrainWidth(width, windowWidth);
};
